<template>
    <div class="menu-page">
        <!-- 搜索框 -->
        <el-input placeholder="菜单编号(回车键搜索)" v-model="searchKey" @keyup.enter.native="handleSearch"
            style="width: 180px; margin-bottom: 20px;" clearable @clear="handleClearSearch"></el-input>

        <!-- 表格 -->
        <el-table :data="menuList" border style="width: 100%;"
            :header-cell-style="{ background: '#f5f7fa', color: '#333' }" v-loading="loading">
            <el-table-column prop="index" label="序号" width="50" align="center"
                :formatter="formatIndex"></el-table-column>
            <el-table-column prop="menuTypeId" label="菜单编号"></el-table-column>
            <el-table-column prop="menuName" label="菜单名称"></el-table-column>
            <el-table-column prop="menuSpell" label="菜单简码" align="center"></el-table-column>
            <el-table-column prop="menuTypeId" label="菜单类型编号" align="center"></el-table-column>
            <el-table-column prop="menuTypeName" label="菜单类型" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-view"
                        @click="goToDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页控件 -->
        <div class="pagination-container" style="margin-top: 20px; text-align: center;">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.totalCount" background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchKey: '', // 搜索关键字
            menuList: [], // 菜单列表数据
            loading: false, // 加载状态
            // 分页参数
            pagination: {
                currentPage: 1, // 当前页码
                pageSize: 10,   // 每页条数
                totalCount: 0   // 总记录数
            },
            // 搜索条件（用于分页时携带）
            searchParams: {
                menuCode: '' // 菜单编号搜索条件
            }
        }
    },
    created() {
        this.getTemplateList();
    },
    methods: {
        // 格式化序号（分页后正确显示）
        formatIndex(row, column) {
            console.log(column);

            return (this.pagination.currentPage - 1) * this.pagination.pageSize + (this.menuList.indexOf(row) + 1);
        },

        // 获取菜单列表（支持分页和搜索）
        async getTemplateList() {
            this.loading = true;
            try {
                const url = 'https://www.zhongyanzhiye.com:8090/chelmeyAI/openAPI/selectMenu';

                // 构造请求参数
                const requestParams = {
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                    merchantId: 'jbtjbtct001',
                    // 携带搜索条件
                    ...(this.searchParams.menuCode ? { menuCode: this.searchParams.menuCode } : {})
                };

                // POST 请求配置
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(requestParams)
                });



                const result = await response.json();

                // 处理返回数据

                // 假设后端返回格式：{ result: { rows: [], total: 0 } }
                this.menuList = result.result.rows || [];
                this.pagination.totalCount = result.result.total || 0;


                console.log('菜单列表数据:', result);

            } catch (error) {
                console.error('获取菜单列表失败:', error);
                this.$message.error('加载数据失败，请重试');
                this.menuList = [];
                this.pagination.totalCount = 0;
            } finally {
                this.loading = false;
            }
        },

        /**
         * 搜索菜单
         */
        handleSearch() {
            if (!this.searchKey) {
                this.$message.warning('请输入菜单编号');
                return;
            }

            // 设置搜索条件
            this.searchParams.menuCode = this.searchKey;
            // 重置页码为第一页
            this.pagination.currentPage = 1;
            // 重新请求数据
            this.getTemplateList();
        },

        /**
         * 清空搜索
         */
        handleClearSearch() {
            this.searchKey = '';
            this.searchParams.menuCode = '';
            this.pagination.currentPage = 1;
            this.getTemplateList();
        },

        /**
         * 每页条数改变
         * @param {Number} val - 每页条数
         */
        handleSizeChange(val) {
            this.pagination.pageSize = val;
            this.pagination.currentPage = 1; // 重置页码
            this.getTemplateList();
        },

        /**
         * 当前页码改变
         * @param {Number} val - 当前页码
         */
        handleCurrentChange(val) {
            this.pagination.currentPage = val;
            this.getTemplateList();
            // 滚动到页面顶部
            window.scrollTo(0, 0);
        },

        /**
         * 打开详情弹窗
         * @param {Object} row - 当前行数据
         */
        goToDetail(row) {
            // 处理空值，避免显示undefined
            const formatValue = (value) => value || '-';

            // 构造详情表格的HTML内容
            const detailHtml = `
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; width: 25%; background: #f5f7fa;">菜单编号</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.menuId)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; width: 25%; background: #f5f7fa;">菜单名称</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.menuName)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">菜单简码</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.menuSpell)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">菜单类型编号</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.menuTypeId)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">菜单类型</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.menuTypeName)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">商户编号</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.merchantCode)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">热量（克）</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.calorie)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">蛋白质（克）</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.protein)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">脂肪（克）</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.fat)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">纤维素（克）</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.cellulose)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">碳水化合物（克）</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.carbohydrate)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">钠（毫克）</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.sodium)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">价格1</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.price1)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">价格2</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.price2)}</td>
                    </tr>
                    <tr>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;">价格3</td>
                        <td style="border: 1px solid #ddd; padding: 8px;">${formatValue(row.price3)}</td>
                        <td style="border: 1px solid #ddd; padding: 8px; background: #f5f7fa;"></td>
                        <td style="border: 1px solid #ddd; padding: 8px;"></td>
                    </tr>
                </table>
            `;

            // 弹窗展示详情
            this.$alert(detailHtml, '菜单详情', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                customClass: 'menu-detail-dialog',
                center: true
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.menu-page {
    padding: 20px;
    background-color: #fff;
    min-height: calc(100vh - 40px);

    .el-input {
        margin-bottom: 20px;
    }

    .el-table {
        --el-table-header-text-color: #333;
        --el-table-header-font-weight: 500;
    }

    // 分页控件样式优化
    .pagination-container {
        .el-pagination {
            --el-pagination-text-color: #666;
            --el-pagination-button-color: #409eff;
            --el-pagination-button-hover-color: #66b1ff;
        }
    }
}

::v-deep .menu-detail-dialog {
    width: 600px !important;
    max-width: 90vw !important; // 适配小屏幕

    .el-dialog__body {
        padding: 16px;
        max-height: 70vh;
        overflow-y: auto;
    }

    // 详情表格样式优化
    table {
        font-size: 14px;

        tr:nth-child(even) {
            background-color: #f9f9f9;
        }

        td {
            word-break: break-all;
        }
    }
}

// 加载中样式
::v-deep .el-loading-mask {
    background-color: rgba(255, 255, 255, 0.8);
}

::v-deep .el-loading-spinner {
    top: 40%;
}
</style>